"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnimation = exports.default = void 0;
var _react = require("react");
const reducer = (state, newState) => ({
  ...state,
  ...newState
});
const useAnimation = (props, delay = 500) => {
  const [state, setState] = (0, _react.useReducer)(reducer, {
    active: props.active,
    canRender: props.active
  });
  (0, _react.useEffect)(() => {
    let activateTimeout = null;
    let unrenderTimeout = null;
    if (props.active && !state.canRender) {
      setState({
        canRender: true
      });
    }
    if (props.active && state.canRender) {
      activateTimeout = setTimeout(() => setState({
        active: true
      }), 100);
    }
    if (!props.active && state.canRender) {
      setState({
        active: false
      });
      unrenderTimeout = setTimeout(() => setState({
        canRender: false
      }), delay);
    }
    return () => {
      clearTimeout(activateTimeout);
      clearTimeout(unrenderTimeout);
    };
  }, [props.active, delay, state.canRender]);
  return [state.active, state.canRender];
};
exports.useAnimation = useAnimation;
var _default = exports.default = useAnimation;